const appName = process.env.REACT_APP_NAME as string
const cdnPrefix = process.env.REACT_APP_CDN_PREFIX as string
const releaseEnv = process.env.REACT_APP_RELEASE_ENV as string
const isProd = releaseEnv === 'production'
// 生产环境使用二级域名，测试环境使用三级域名
const env = isProd ? '' : '.' + releaseEnv

export const config = {
  appName,
  apiUrl: `//pcapi${env}.${appName}.com/v1/`,
  cdnUrl: isProd
    ? `//${cdnPrefix}.${appName}.com`
    : '//cdnimgtest.yijiahaohuo.com',
}

export const apiDomain = config.apiUrl
export const version = 20260910
